<template>
  <div>

    <!-- filter devices -->
    <toggle-collapse>


      <DevicesListFilters 
      :haseSupportFilter="true"
      :filterFor="report_type"
       :oldFilterData="request"
        @divicesFilterd="divicesFilterd"
        @merageFilterWithRequest="merageFilterWithRequest" />


    </toggle-collapse>

    <!-- form report -->
    <b-card style="position: relative">

      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">

          <!-- devices  -->
          <b-col cols="12">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices" 
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{ name: $t('all'), id: 'all' }, ...devices]"
                :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>



          <b-col v-if="report_type=='report'" md="12" sm="12">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" 
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type=='report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type=='setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('status')">
              {{ $t('Save Setings') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="dataTableloading||loading"
        :getReport="getReport" :total="total" :from="from" :to="to"   :sortData="sortData" />

    </div>


  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted } from '@vue/composition-api'

import StatusReportLogic from '@/app/reports/status/logic'
import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'


import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'



import { ExportDataServices } from '@/share/reports/exportService'
import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'

import { ReportSetting } from '@/views/reports/ReportSettings'
import ReportOptions from '@/views/reports/components/options.js'
import DataTable from '@/views/reports/data-table/DataTable.vue'
export default {
  name: 'StatusReport',
  components: {
    BRow,
    BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput, flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    DevicesListFilters,
    ToggleCollapse,
    DataTable

  },
  directives: {
    Ripple,
  },
  props: {
    report_type: {
      type: String,
      default: 'report'

    }
  },
  setup(props, { root, refs }) {

    const rangeDate = ref('')
    const filter_included_fields = ['contract', 'owner', 'device_name', 'day', 'camp_leave', 'started_work', 'finished_work', 'duration_string', 'total_distance'];
    const report_fields = [
      {
        key: 'index',
        label:'id',
       
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },
      {
        key: 'device_name',
        label: 'device',
        sortable: true
      },
      {
        key: 'day',
        label: 'day',
        sortable: true
      },
      {
        key: 'camp_leave',
        label: 'camp leave',
        sortable: true
      },
      {
        key: 'started_work',
        label: 'started work',
        sortable: true
      },
      {
        key: 'finished_work',
        label: 'finished work',
        sortable: true
      },
      {
        key: 'duration_string',
        label: 'duration time',
        sortable: true
      },
      {
        key: 'total_distance',
        label: 'total distance',
        sortable: true
      },
      


    ];

    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }
    const { devices } = FilterLogic()
    const divicesFilterd = (data) => {
      devices.value = data;
    }
    const merageFilterWithRequest = (data) => {
      delete data['type']
      if (data['isSupport'] == "all") {
        delete data['isSupport']
        delete request.value.isSupport
      }
      Object.assign(request.value, data);
    }




    const tableRef = ref(null)

    const { report_data, request, date, errors, loading, getReport, total, from, to ,isSortDirDesc,sortBy,dataTableloading} = StatusReportLogic()
    const { pickerOptions } = ReportOptions(request.value)
    const perPageOptions = [5, 10, 25, 50, 100]



    const report_wrapper = ref(null)







    /// here use this form ass dialy report setting

    const toaster = (msg, variant = 'success', title = 'Success') => {
      root.$root.$bvToast.toast(
        root.$i18n.t(msg), {
        title: root.$i18n.t(title),
        variant,
        solid: true,
      })
    }
    const saveDialySetting = (reportName) => {
      let setting_data = request.value;
      delete setting_data.to;
      delete setting_data.from;

      ReportSetting.setSettings(reportName, setting_data).then((res) => {
        toaster('settigs saved succeffly!!', 'success!!')
      }).catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }
    onMounted(() => {
      if (props.report_type == 'setting') {
        ReportSetting.getSetting('status').then((res) => {
          request.value = res;

        })
      }
    })
    //here end of   dialy report setting


    return {
      report_data, filter_included_fields, report_fields, total, from, to, rangeDate,
      tableRef,
      getReport,

      perPageOptions,

      devices,

      pickerOptions,
      report_wrapper,

      request, date,
      loading,
      errors,
      divicesFilterd,
      merageFilterWithRequest,
      //dialy report setting 
      saveDialySetting,
      sortData,
      dataTableloading

    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
